import DropDownControl from '../shared/controls/drop-down';
import React from 'react';
import regionData from '../../../public/json/regions/all-regions.json';

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange=this.handleChange.bind(this);
  }
  regions(magazine) {
    return regionData.map(region => {
      return {
        label: region.label,
        link: `${region.value}`,
      };
    });
  }
  handleChange(e){
    this.props.currentMarketUpdate(e);
  }
  render() {
    return (
      <div>
        <div className="pHead">
            <h1>Local Experts. Worldwide.</h1>
            <p>View the most recent Market Update for other markets we serve in the United States.</p>
        </div>
        <DropDownControl  id="2"
          label="SELECT A DIFFERENT MARKET "
          items={this.regions(this.props.magazine)}
          handleChange={this.handleChange}
        />
      </div>
    );
  }
}
export default  DropDown;


// WEBPACK FOOTER //
// ./src/components/market-update/dropdown.jsx